import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppFilter } from '@app/shared/models';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';

import { DynamicHeaderService } from '../services/dynamic-header.service';
import { ConfirmModal } from '@app/shared/modals';
import { ThrowStmt } from '@angular/compiler';
import { editDynamicHeaderModal } from '../modals/edit-dynamic-header/edit-dynamic-header.component';
import { Router } from '@angular/router';
import { PermissionService } from '../services/permission.service';

@Component({
  selector: 'app-dynamic-header',
  templateUrl: './dynamic-header.component.html',
  styleUrls: ['./dynamic-header.component.scss'],
})
export class DynamicHeaderComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  // headers: Array<any> = [];
  success: any;
  error: any;
  headerFilters: any[];
  headers = [
    {
      field: 'headerKey',
      label: 'Header Name',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'headerKey',
      label: 'Value',
      type: 'text',
      op: 'cn',
      data: '',
    },
  ];

  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'headerKey',
        op: 'cn',
        data: '',
      },
      {
        field: 'headerValue',
        op: 'cn',
        data: '',
      },
    ],
  };
  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: this.rows,
      _search: false,
    });

    this.getPage(1);
  }
  advancedSearch(e) {
    if (e) {
      this.filter._search = true;
      this.filter.filters = JSON.stringify(e);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.filter.page = 1;

    this.getPage(1);
  }

  constructor(
    private location: Location,
    private permissionService: PermissionService,
    private headerSvc: DynamicHeaderService,
    private modalService: SuiModalService,
    private router: Router
  ) {
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 10,
      sord: 'desc',
    });
    this.getPage(1);
  }
  ngOnInit(): void {}

  dynamicHeader = [
    {
      headerKey: 'Profile 1',
      headerValue: 'Cache-control, Clear-Site-Data',
      createdBy: 'Tolulope Idris',
      dateCreated: new Date(),
    },
    {
      headerKey: 'Profile 1',
      headerValue: 'Cache-control, Clear-Site-Data',
      createdBy: 'Tolulope Idris',
      dateCreated: new Date(),
    },
    {
      headerKey: 'Profile 1',
      headerValue: 'Cache-control, Clear-Site-Data',
      createdBy: 'Tolulope Idris',
      dateCreated: new Date(),
    },
  ];
  totalItems: number = 0;

  goBack() {
    this.router.navigateByUrl('/admin/setting/application-security');
  }
  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.headerSvc
      .getHeaderConfig({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.headers = res['rows'];
          this.totalItems = +res.records;
        },
        (error) => {
          this.pending = false;
          this.error = error.error ? error.error : error;
        }
      );
  }
  searchRecords(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'headerKey',
          op: 'cn',
          data: '',
        },
        {
          field: 'headerValue',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }

  editHeader(header) {
    this.modalService
      .open(
        new editDynamicHeaderModal(
          'Edit Header',
          {
            headerKey: header.headerKey,
            headerValue: header.headerValue,
            headerConfigId: header.headerConfigId,
          },
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
  addHeader() {
    this.modalService
      .open(
        new editDynamicHeaderModal(
          'Add Header',
          {
            isAdd: true,
          },
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }
  sortRecords(search) {
    this.filter.sord = search;
    this.filter.sidx = 'desc';
    this.getPage(1);
  }

  delete(header) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Header',
          'Are you sure you want to delete this Header?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.pending = true;
        this.headerSvc
          .deleteHeaderConfig({
            headerConfigId: header.headerConfigId,
          })
          .subscribe(
            (res) => {
              this.pending = false;
              this.success = 'Header Deleted Succesfully';
              this.getPage(1);
            },
            (error) => {
              this.pending = false;
              this.error = error.error ? error.error : error;
            }
          );
      })
      .onDeny(() => {});
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  checkPermission(event: { id: string; action: string }): boolean {
    const { id, action } = event;
    return this.permissionService.checkPermission(id, action);
  }
}
